// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const ISOCHRONE_SMOOTHING_VALUES = [
  'VERY_DETAILED',
  'DETAILED',
  'DETAILED_2',
  'DETAILED_3',
  'DETAILED_4',
  'MEDIUM',
  'GENERIC',
  'GENERIC_20',
  'VERY_GENERIC',
  'VERY_GENERIC_75',
  'VERY_GENERIC_100',
] as const;

/** @see net/disy/cadenza/routing/param/isochrone/IsochroneSmoothing.java */
export type IsochroneSmoothing = (typeof ISOCHRONE_SMOOTHING_VALUES)[number];

export const IsochroneSmoothing = {
  values: ISOCHRONE_SMOOTHING_VALUES as readonly IsochroneSmoothing[],
} as const;

// </GENERATED-CODE>
